import React from 'react';
import { Link } from 'react-router-dom';

import SchoolList from 'components/schools/SchoolList';
import KitOrdersList from 'components/kit-orders/details/KitOrdersList';
import TeachersListItem from 'components/teachers/TeacherListItem';

import Gravatar from 'react-gravatar';

class TeacherDetails extends React.Component {
  render() {
    const teacher = this.props.teacher;
    if (!teacher) {
      return '<p>TEACHER MISSING</p>';
    }
    const paragraphStyle = {
      fontSize: '140%'
    }

    const kits = teacher.kits ? teacher.kits.map((kitId) => {
      return <li style={paragraphStyle}>{kitId}</li>;
    }) : [];

    let ordersByKit = {};
    if (teacher.orders) {
      teacher.orders.forEach((order) => {
        let orderKitIds = [];

        order.items.forEach((item) => {
          if (orderKitIds.indexOf(item.kit_id) == -1) {
            orderKitIds.push(item.kit_id);
          }
        });

        orderKitIds.forEach((kitId) => {
          if (ordersByKit[kitId] == undefined) {
            ordersByKit[kitId] = [];
          }

          ordersByKit[kitId].push(order);
        });
      });
    }

    return (
      <div className="container">
        <div className="row">
          <div className="col-8">
            <h1 className="clearfix mb-4">
              <Gravatar email={teacher.email} size={70} className="float-left mr-2" alt="" rel="noreferrer" /> {teacher.first_name + ' ' + teacher.last_name}

              <small style={{display: 'block',fontSize: '60%'}}>
                <a href={'mailto:' + teacher.email}>{teacher.email}</a>
              </small>
            </h1>
          </div>
          <div className="col-4">
            {
              teacher.schools && teacher.schools[0] && (
                <div>
                  <i className="fa fa-phone mr-1" /> {teacher.phone && ['NO', 'N/D', 'N/A'].indexOf(teacher.phone) === -1 ? <a href={`tel:${teacher.phone}`}>{teacher.phone}</a> : 'N/D'}<br />
                  <i className="fa fa-school mr-1" /> {teacher.schools[0].type})<br />
                  <i className="fa fa-city mr-1" /> {teacher.schools[0].city_name} ({teacher.schools[0].province_iso_code})
                </div>
              )
            }
          </div>
        </div>
        <div className="row">
        <div className="col-12">
            {
              teacher.schools && (
                <div className="card mb-3">
                  <div className="card-header">
                    <h2><i className="fa fa-building" /> {teacher.schools.length + ' ' + (teacher.schools.length == 1 ? 'scuola' : 'scuole')}</h2>
                  </div>
                  <div className="card-body">
                    <SchoolList schools={teacher.schools} />
                  </div>
                </div>
              )
            }
            {
              teacher.collegues && (
                <div className="card mb-3">
                  <div className="card-header">
                    <h2><i className="fa fa-users" /> {teacher.collegues.length + ' ' + (teacher.collegues.length == 1 ? 'collega' : 'colleghi')}</h2>
                  </div>
                  <div className="card-body">
                    <table className="mt-2">
                    {
                      teacher.collegues.map((collegue) => {
                        console.dir(collegue);

                        collegue.id = collegue.teacher_key;

                        return (
                          <TeachersListItem teacher={collegue} />
                        );
                      })
                    }
                    </table>
                  </div>
                </div>
              )
            }

            {
              teacher.kits && (
                <div className="card mb-3">
                  <div className="card-header">
                    <h2><i className="fa fa-shopping-cart" /> {teacher.orders.length + ' ' + (teacher.orders.length == 1 ? 'ordine' : 'ordini')} in {teacher.kits.length} kit</h2>
                  </div>
                  <div className="card-body">
                    {/* <KitList kits={teacher.kits} /> */}
                    {/* TODO: create component */}
                    {
                      teacher.kits.map((kit) => {
                        return (
                          <div>
                            <div className="row">
                              <div className="col-9">
                                <span className={'badge ' + (kit.schoolyear == (new Date).getFullYear() ? 'badge-primary' : 'badge-secondary')}>
                                  {'Edizione ' + kit.schoolyear + '/' + (parseInt(String(kit.schoolyear).substring(2, 4))+1)}
                                </span>
                                <h3 className="card-title mt-0 mb-3">
                                  {kit.name}
                                </h3>
                                {/* {
                                  kit.subtitle ? <h4 className="card-title text-secondary mt-0 mb-0">{kit.subtitle}</h4> : ''
                                } */}
                              </div>
                              <div className="col-3 text-right">
                                <div style={{position: 'relative', top: '50%', transform: 'translateY(-50%)'}}>
                                  <Link to={'/kits/overview/'} className="btn btn-sm btn-secondary">
                                    <i className="fa fa-arrow-right" /> vai al kit
                                  </Link>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12">
                                <KitOrdersList orders={ordersByKit[kit.id]} />
                              </div>
                            </div>

                            <hr />
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              )
            }
          {
            this.props.surveys.length && (
              <div className="card mb-3">
                <div className="card-header">
                  <h2><i className="fa fa-poll" /> Sondaggi</h2>
                </div>
                <div className="card-body">
                  {
                    this.props.surveys.map((survey) => {
                      return (
                        <div>
                          <div className="row">
                            <div className="col-9">
                              <h3 className="card-title mt-0 mb-3">
                                {survey.title}
                              </h3>
                              <p>{survey.descr}</p>
                            </div>
                            <div className="col-3 text-right">
                              <div style={{position: 'relative', top: '50%', transform: 'translateY(-50%)'}}>
                                <Link to={'/marketing/surveys/' + survey.id + '/view/' + teacher.teacher_key + '/'} className="btn btn-sm btn-secondary">
                                  <i className="fa fa-arrow-right" /> somministra
                                </Link>
                              </div>
                            </div>
                          </div>

                          <hr />
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            )
          }
          </div>
        </div>

        <div className="row">
          <div className="col-12">

          </div>
        </div>
      </div>
    );
  }
}

export default TeacherDetails;



// WEBPACK FOOTER //
// ./src/components/teachers/TeacherDetails.js